import { agent } from "./agent";
import { BasicUserInfo } from '@shared/models/user.models';

interface CompanyAdmins {
  companyAdmins: BasicUserInfo[];
  allTeamAdmins: BasicUserInfo[];
}

function fetchAdmins(): Promise<CompanyAdmins> {
  return agent.requests.get('/api/company/admins');
}

export interface TenantResponse {
  id: string;
  logoUrl: string;
  name: string;
  companyId: string;
}

export function checkTenant(tenantId?: string): Promise<TenantResponse | null> {
  if (!tenantId) return new Promise<TenantResponse | null>((resolve => resolve(null)));
  return agent.requests.get(`/tenant-id/${tenantId}`)
}
